module.exports = __webpack_public_path__ + "static/media/flutter.8c66e9c4.png";